import { createContext, useContext } from 'react';

export interface ClientConfig {
  clientId: string;
  baseUrl: string;
}

export const ClientConfigContext = createContext<ClientConfig>({
  clientId: '',
  baseUrl: window.location.href,
});

export const useClientConfig = () => useContext(ClientConfigContext);
